(() => {
  "use strict";

  const PREMIUM_GIFT_VARIANT_IDS = [
  58448199287119, // Saddle Soap
  58448199319887, // Citronella+ Concentrate
  58448199352655, // Wound Guard Spray
  58448199385423  // Leather Luxe
];
  const PREMIUM_THRESHOLD = 3000; // £30 in pence
const GIFT_PROPERTY = "_premium_extra";

const EXCLUDED_PRODUCT_IDS = [
  16158533189967 // Parlour Pals
];

const EXCLUDED_PRODUCT_HANDLES = [
  "parlour-pals-samples-100ml"
];

const EXCLUDED_VARIANT_IDS = [
  57982041948495, // FlyBusta 5L
  57982035460431  // Citronella+ 5L
];

  const originalFetch = window.fetch.bind(window);

  let updateTimer = null;
  let isSynchronising = false;
  let rerunRequested = false;

  function rootUrl() {
    return window.Shopify?.routes?.root || "/";
  }

  function money(pence) {
    return new Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: "GBP"
    }).format(Number(pence || 0) / 100);
  }

  function isGift(item) {
  return (
    PREMIUM_GIFT_VARIANT_IDS.includes(
      Number(item?.variant_id)
    ) &&
    item?.properties?.[GIFT_PROPERTY] === "true"
  );
}

  async function isExcludedFromPremiumOrder(item) {

  if (
    !item ||
    isGift(item)
  ) {
    return false;
  }


  const productId =
    Number(
      item.product_id ||
      0
    );


  const variantId =
    Number(
      item.variant_id ||
      0
    );


  const productHandle =
    String(
      item.handle ||
      ""
    );


  /*
    Exclude whole products by product ID
  */
  if (
    EXCLUDED_PRODUCT_IDS.includes(
      productId
    )
  ) {
    return true;
  }


  /*
    Exclude whole products by Shopify handle.

    This is what excludes all variants of the
    Parlour Pals 100ml sample product.
  */
  if (
    EXCLUDED_PRODUCT_HANDLES.includes(
      productHandle
    )
  ) {
    return true;
  }


  /*
    Exclude individual variants
  */
  if (
    EXCLUDED_VARIANT_IDS.includes(
      variantId
    )
  ) {
    return true;
  }


  return false;
}


  async function getPremiumOrderTotals(cart) {
    const items =
      cart?.items || [];

    let subtotal = 0;
    let qualifyingItemCount = 0;

    for (const item of items) {

      /*
        The complimentary gift never contributes.
      */
      if (isGift(item)) {
        continue;
      }

      /*
        Excluded products and specific excluded
        variants do not contribute.
      */
      const excluded =
        await isExcludedFromPremiumOrder(
          item
        );

      if (excluded) {
        continue;
      }

      subtotal +=
        Number(
          item.final_line_price ||
          0
        );

      qualifyingItemCount += 1;
    }

    return {
      subtotal,
      qualifyingItemCount
    };
  }


  async function getCart() {
    const response =
      await originalFetch(
        `${rootUrl()}cart.js`,
        {
          headers: {
            Accept: "application/json"
          },
          cache: "no-store"
        }
      );

    if (!response.ok) {
      throw new Error(
        "Unable to retrieve the cart."
      );
    }

    return response.json();
  }


  async function addGift() {

  const shuffledGiftIds =
    [...PREMIUM_GIFT_VARIANT_IDS]
      .sort(
        () => Math.random() - 0.5
      );


  /*
    Ask Shopify for the visible cart sections
    at the same time as we add the gift.
  */
  const sectionIds = [];


  const mainCartItems =
    document.querySelector(
      "#main-cart-items"
    );


  const mainCartFooter =
    document.querySelector(
      "#main-cart-footer"
    );


  if (
    mainCartItems?.dataset?.id
  ) {

    sectionIds.push(
      mainCartItems.dataset.id
    );

  }


  if (
    mainCartFooter?.dataset?.id &&
    !sectionIds.includes(
      mainCartFooter.dataset.id
    )
  ) {

    sectionIds.push(
      mainCartFooter.dataset.id
    );

  }


  for (
    const variantId of shuffledGiftIds
  ) {

    try {

      const payload = {

        items: [
          {
            id: variantId,

            quantity: 1,

            properties: {
              [GIFT_PROPERTY]:
                "true"
            }
          }
        ]

      };


      /*
        If the customer is currently on the
        main cart page, return the freshly
        rendered cart sections with the add.
      */
      if (sectionIds.length) {

        payload.sections =
          sectionIds;


        payload.sections_url =
          window.location.pathname;

      }


      const response =
        await originalFetch(
          `${rootUrl()}cart/add.js`,
          {
            method: "POST",

            headers: {

              "Content-Type":
                "application/json",

              Accept:
                "application/json"

            },

            body:
              JSON.stringify(
                payload
              )
          }
        );


      if (!response.ok) {
        continue;
      }


      const result =
        await response.json();


      /*
        Immediately repaint the MAIN CART
        using the section HTML returned from
        the exact same request that added
        the free gift.
      */
      if (
        result.sections &&
        mainCartItems?.dataset?.id
      ) {

        const html =
          result.sections[
            mainCartItems.dataset.id
          ];


        if (html) {

          const parsed =
            new DOMParser()
              .parseFromString(
                html,
                "text/html"
              );


          const fresh =
            parsed.querySelector(
              "#main-cart-items"
            );


          if (fresh) {

            mainCartItems.innerHTML =
              fresh.innerHTML;

          }

        }

      }


      if (
        result.sections &&
        mainCartFooter?.dataset?.id
      ) {

        const html =
          result.sections[
            mainCartFooter.dataset.id
          ];


        if (html) {

          const parsed =
            new DOMParser()
              .parseFromString(
                html,
                "text/html"
              );


          const fresh =
            parsed.querySelector(
              "#main-cart-footer"
            );


          if (fresh) {

            mainCartFooter.innerHTML =
              fresh.innerHTML;

          }

        }

      }


      return result;

    }

    catch (error) {

      console.warn(
        `Premium gift ${variantId} could not be added.`,
        error
      );

    }

  }


  throw new Error(
    "No Premium Order gifts are currently available."
  );

}


  async function changeGift(
    itemKey,
    quantity
  ) {
    const response =
      await originalFetch(
        `${rootUrl()}cart/change.js`,
        {
          method: "POST",

          headers: {
            "Content-Type":
              "application/json",

            Accept:
              "application/json"
          },

          body: JSON.stringify({
            id: itemKey,
            quantity:
              Number(quantity)
          })
        }
      );

    if (!response.ok) {
      throw new Error(
        "Unable to update the complimentary extra."
      );
    }

    return response.json();
  }


  async function updateRewardCards(cart) {
    const totals =
      await getPremiumOrderTotals(
        cart
      );

    const subtotal =
      totals.subtotal;

    const hasQualifyingProducts =
      totals.qualifyingItemCount > 0;

    const unlocked =
      subtotal >=
      PREMIUM_THRESHOLD;

    const remaining =
      Math.max(
        PREMIUM_THRESHOLD -
        subtotal,
        0
      );

    const percentage =
      Math.min(
        Math.round(
          (
            subtotal /
            PREMIUM_THRESHOLD
          ) * 100
        ),
        100
      );


    /*
      Hide Premium Order completely when the
      basket contains only excluded products.
    */
    function showOrHide(card) {
      if (!card) {
        return;
      }

      if (hasQualifyingProducts) {

        card.hidden = false;

        card.style.removeProperty(
          "display"
        );

      } else {

        card.hidden = true;

        card.style.setProperty(
          "display",
          "none",
          "important"
        );

      }
    }


    function setWidth(element) {
      if (!element) {
        return;
      }

      element.style.setProperty(
        "width",
        `${percentage}%`,
        "important"
      );
    }


    /*
      LARGE PREMIUM ORDER CARD
    */
    document
      .querySelectorAll(
        ".arlo-wow"
      )
      .forEach(
        (card) => {

          showOrHide(card);

          if (
            !hasQualifyingProducts
          ) {
            return;
          }

          card.classList.toggle(
            "arlo-wow--unlocked",
            unlocked
          );

          const kicker =
            card.querySelector(
              ".arlo-wow__kicker"
            );

          const burst =
            card.querySelector(
              ".arlo-wow__free-burst"
            );

          const amount =
            card.querySelector(
              ".arlo-wow__amount"
            );

          const headline =
            card.querySelector(
              ".arlo-wow__headline"
            );

          const body =
            card.querySelector(
              ".arlo-wow__body"
            );

          const progressTop =
            card.querySelector(
              ".arlo-wow__progress-top"
            );

          const progressBar =
            card.querySelector(
              ".arlo-wow__track"
            );

          const progressFill =
            card.querySelector(
              ".arlo-wow__fill"
            );

          const nudge =
            card.querySelector(
              ".arlo-wow__nudge"
            );


          if (unlocked) {

            if (kicker) {
              kicker.textContent =
                "YOUR PREMIUM ORDER IS READY";
            }

            if (burst) {
              burst.textContent =
                "YOURS";
            }

            if (amount) {

              amount.textContent =
                "UNLOCKED!";

              amount.classList.add(
                "arlo-wow__amount--unlocked"
              );

            }

            if (headline) {

              headline.innerHTML =
                "Your FREE arlo.® surprise has been added";

            }

            if (body) {

              body.innerHTML =
                "You’ve unlocked your complimentary surprise extra and " +
                "<strong>FREE UK delivery</strong>. Consider this our little thank you.";

            }

            if (progressTop) {

              progressTop.innerHTML =
                "<span>Premium Order complete</span><strong>100%</strong>";

            }

            if (nudge) {

              nudge.hidden = true;

              nudge.style.display =
                "none";

            }

          } else {

            if (kicker) {

              kicker.textContent =
                "YOUR CART IS SO CLOSE";

            }

            if (burst) {

              burst.textContent =
                "FREE";

            }

            if (amount) {

              amount.textContent =
                `Just ${money(remaining)}`;

              amount.classList.remove(
                "arlo-wow__amount--unlocked"
              );

            }

            if (headline) {

              headline.innerHTML =
                "away from a FREE arlo.® surprise";

            }

            if (body) {

              body.innerHTML =
                "Add one more favourite to reach £30 and we’ll automatically pop a " +
                "<strong>complimentary mystery extra</strong> into your order, with " +
                "<strong>FREE UK delivery</strong> too.";

            }

            if (progressTop) {

              progressTop.innerHTML =
                `<span>${money(subtotal)} of £30 reached</span>` +
                `<strong>${percentage}%</strong>`;

            }

            if (nudge) {

              nudge.hidden = false;

              nudge.style.display =
                "";

            }
          }


          if (progressBar) {

            progressBar.setAttribute(
              "aria-valuenow",
              String(percentage)
            );

          }

          setWidth(
            progressFill
          );

        }
      );
    /*
      COMPACT PREMIUM ORDER CARD
    */
    document
      .querySelectorAll(
        "[data-premium-order]"
      )
      .forEach(
        (card) => {

          showOrHide(card);

          if (
            !hasQualifyingProducts
          ) {
            return;
          }

          card.classList.toggle(
            "premium-order--unlocked",
            unlocked
          );

          const heading =
            card.querySelector(
              ".premium-order__heading"
            );

          const message =
            card.querySelector(
              "[data-premium-order-message]"
            );

          const fill =
            card.querySelector(
              "[data-premium-order-fill]"
            );

          const progress =
            card.querySelector(
              "[data-premium-order-progress]"
            );

          const note =
            card.querySelector(
              ".premium-order__note"
            );


          if (heading) {

            heading.textContent =
              unlocked
                ? "FREE GIFT UNLOCKED"
                : `${money(remaining)} AWAY FROM A FREEBIE`;

          }


          if (message) {

            message.innerHTML =
              unlocked
                ? "Your <strong>FREE arlo.® surprise</strong> has been added automatically."
                : `Add another <strong>${money(remaining)}</strong> to unlock your FREE arlo.® surprise.`;

          }


          setWidth(
            fill
          );


          if (progress) {

            progress.setAttribute(
              "aria-valuenow",
              String(percentage)
            );

          }


          if (note) {

            note.textContent =
              unlocked
                ? "Unlocked at £30."
                : `${percentage}% of the way there`;

          }

        }
      );


    /*
      CURRENT MAIN CART + CART DRAWER REWARD
    */
    document
      .querySelectorAll(
        ".arlo-drawer-reward"
      )
      .forEach(
        (card) => {

          showOrHide(card);

          if (
            !hasQualifyingProducts
          ) {
            return;
          }


          const heading =
            card.querySelector(
              ".arlo-drawer-reward__heading"
            );


          const message =
            card.querySelector(
              ".arlo-drawer-reward__message"
            );


          const note =
            card.querySelector(
              ".arlo-drawer-reward__note"
            );


          const track =
            card.querySelector(
              ".arlo-drawer-reward__track"
            );


          const fill =
            card.querySelector(
              ".arlo-drawer-reward__fill, " +
              "[data-premium-order-fill], " +
              "[data-arlo-reward-fill], " +
              ".premium-order__fill"
            ) ||
            (
              track
                ? track.firstElementChild
                : null
            );


          card.classList.toggle(
            "is-unlocked",
            unlocked
          );


          if (heading) {

            heading.textContent =
              unlocked
                ? "FREE GIFT UNLOCKED"
                : `${money(remaining)} AWAY FROM A FREEBIE`;

          }


          if (message) {

            message.innerHTML =
              unlocked
                ? "Your <strong>FREE arlo.® surprise</strong> has been added automatically."
                : `Add another <strong>${money(remaining)}</strong> of qualifying products to unlock your FREE arlo.® surprise.`;

          }


          if (track) {

            track.setAttribute(
              "aria-valuemin",
              "0"
            );

            track.setAttribute(
              "aria-valuemax",
              "100"
            );

            track.setAttribute(
              "aria-valuenow",
              String(percentage)
            );

          }


          setWidth(
            fill
          );


          if (note) {

            note.textContent =
              unlocked
                ? "Unlocked at £30."
                : `${money(subtotal)} qualifying spend · ${percentage}% of the way there`;

          }

        }
      );

  }


  async function synchroniseGift(cart) {

    const totals =
      await getPremiumOrderTotals(
        cart
      );


    const subtotal =
      totals.subtotal;


    const qualifies =
      subtotal >=
      PREMIUM_THRESHOLD;


    const gifts =
      (cart.items || [])
        .filter(isGift);


    /*
      Everything is already correct.
      Do absolutely nothing.
    */
    if (
      (
        !qualifies &&
        gifts.length === 0
      ) ||
      (
        qualifies &&
        gifts.length === 1 &&
        Number(
          gifts[0].quantity
        ) === 1
      )
    ) {
      return false;
    }


    /*
      Qualified but no gift.
    */
    if (
      qualifies &&
      gifts.length === 0
    ) {

      await addGift();

      return true;

    }


    /*
      No longer qualified.
      Remove gift.
    */
    if (
      !qualifies &&
      gifts.length > 0
    ) {

      for (
        const gift of gifts
      ) {

        await changeGift(
          gift.key,
          0
        );

      }

      return true;

    }


    /*
      Duplicate gifts.
    */
    if (
      qualifies &&
      gifts.length > 1
    ) {

      for (
        let index = 1;
        index < gifts.length;
        index += 1
      ) {

        await changeGift(
          gifts[index].key,
          0
        );

      }


      if (
        Number(
          gifts[0].quantity
        ) !== 1
      ) {

        await changeGift(
          gifts[0].key,
          1
        );

      }

      return true;

    }


    /*
      Correct gift line but wrong quantity.
    */
    if (
      qualifies &&
      gifts.length === 1 &&
      Number(
        gifts[0].quantity
      ) !== 1
    ) {

      await changeGift(
        gifts[0].key,
        1
      );

      return true;

    }


    return false;
  }


  async function refreshMainCartSections() {

  try {

    /*
      MAIN CART

      Use the theme's own cart refresh method.
      This is the same mechanism Dawn uses when
      cart contents change normally.
    */
    const mainCart =
      document.querySelector(
        "cart-items"
      );

    if (
      mainCart &&
      typeof mainCart.onCartUpdate ===
        "function"
    ) {

      await mainCart.onCartUpdate();

    }


    /*
      CART DRAWER

      If the drawer exists on this page,
      refresh that using the theme's own
      method too.
    */
    const drawerCart =
      document.querySelector(
        "cart-drawer-items"
      );

    if (
      drawerCart &&
      typeof drawerCart.onCartUpdate ===
        "function"
    ) {

      await drawerCart.onCartUpdate();

    }


    /*
      Re-run our Premium Order display
      after Shopify has replaced the
      visible cart HTML.
    */
    const cart =
      await getCart();

    await updateRewardCards(
      cart
    );

  }

  catch (error) {

    console.warn(
      "Native cart refresh skipped:",
      error
    );

  }

}


  async function updateEverything() {

    if (isSynchronising) {

      rerunRequested = true;

      return;

    }


    isSynchronising = true;


    try {

      let cart =
        await getCart();


      await updateRewardCards(
        cart
      );


      const giftChanged =
        await synchroniseGift(
          cart
        );


      if (giftChanged) {

        cart =
          await getCart();


        await updateRewardCards(
          cart
        );


        await refreshMainCartSections();


        cart =
          await getCart();


        await updateRewardCards(
          cart
        );

      }

    } catch (error) {

      console.error(
        "arlo.® Premium Order error:",
        error
      );

    } finally {

      isSynchronising = false;


      if (rerunRequested) {

        rerunRequested = false;

        queueUpdate(
          500
        );

      }

    }
  }


  function queueUpdate(
    delay = 500
  ) {

    window.clearTimeout(
      updateTimer
    );


    updateTimer =
      window.setTimeout(
        () => {

          updateEverything();

        },
        delay
      );
  }

  /*
    ============================================================
    ONE GENERAL CART REQUEST OBSERVER
    ============================================================

    Shopify itself handles:
    - quantity increases
    - quantity decreases
    - removals
    - normal product adds
    - cart drawer updates

    We only watch successful cart requests and then
    recalculate Premium Order once.
  */

  window.fetch =
    async (...argumentsList) => {

      const response =
        await originalFetch(
          ...argumentsList
        );


      try {

        const request =
          argumentsList[0];


        const url =
          typeof request === "string"
            ? request
            : request?.url || "";


        const isCartMutation =
          url.includes("/cart/add") ||
          url.includes("/cart/change") ||
          url.includes("/cart/update") ||
          url.includes("/cart/clear");


        if (
          isCartMutation &&
          response.ok
        ) {

          queueUpdate(
            650
          );

        }

      }

      catch (error) {

        console.warn(
          "Cart request detection skipped:",
          error
        );

      }


      return response;
    };


  /*
    ============================================================
    ARLO CART DRAWER RECOMMENDATION BUTTONS
    ============================================================
  */

  document.addEventListener(
    "click",
    async (event) => {

      const button =
        event.target.closest(
          "[data-arlo-drawer-add]"
        );


      if (
        !button ||
        button.disabled
      ) {
        return;
      }


      event.preventDefault();

      event.stopPropagation();


      const variantId =
        Number(
          button.dataset.variantId
        );


      if (!variantId) {
        return;
      }


      const buttonText =
        button.querySelector(
          "[data-arlo-drawer-button-text]"
        );


      const cartDrawer =
        document.querySelector(
          "cart-drawer"
        );


      button.disabled =
        true;


      if (buttonText) {

        buttonText.textContent =
          "Adding...";

      }


      try {

        let sections = [];


        if (
          cartDrawer &&
          typeof cartDrawer
            .getSectionsToRender ===
            "function"
        ) {

          sections =
            cartDrawer
              .getSectionsToRender()
              .map(
                (section) =>
                  section.id
              );

        }


        const payload = {

          items: [
            {
              id: variantId,
              quantity: 1
            }
          ]

        };


        if (sections.length) {

          payload.sections =
            sections;


          payload.sections_url =
            window.location.pathname;

        }


        const response =
          await originalFetch(
            `${rootUrl()}cart/add.js`,
            {
              method: "POST",

              headers: {

                "Content-Type":
                  "application/json",

                Accept:
                  "application/json"

              },

              body:
                JSON.stringify(
                  payload
                )
            }
          );


        if (!response.ok) {

          throw new Error(
            "Unable to add product."
          );

        }


        const result =
          await response.json();


        if (
          cartDrawer &&
          typeof cartDrawer
            .renderContents ===
            "function" &&
          result.sections
        ) {

          cartDrawer.renderContents(
            result
          );

        }


        if (buttonText) {

          buttonText.textContent =
            "Added";

        }


        /*
          Exactly one Premium Order
          recalculation after this add.
        */
        queueUpdate(
          650
        );


        window.setTimeout(
          () => {

            if (
              !button.isConnected
            ) {
              return;
            }


            button.disabled =
              false;


            if (buttonText) {

              buttonText.textContent =
                "Add";

            }

          },
          1200
        );

      }

      catch (error) {

        console.error(
          "arlo.® drawer recommendation add error:",
          error
        );


        button.disabled =
          false;


        if (buttonText) {

          buttonText.textContent =
            "Try again";

        }

      }

    }
  );


  /*
    ============================================================
    CHECKOUT NUDGE
    ============================================================

    This only appears when:

    1. There is at least one qualifying item.
    2. Qualifying spend is below £30.
    3. The customer actually attempts Checkout.

    Parlour Pals and the excluded 5L variants continue
    to be ignored because this uses getPremiumOrderTotals().
  */

  const CHECKOUT_NUDGE_ID =
    "arlo-checkout-nudge";


  let checkoutNudgeOpen =
    false;


  let approvedCheckoutElement =
    null;


  let approvedCheckoutHref =
    null;


  let checkoutEvaluationInProgress =
    false;


  function injectCheckoutNudgeStyles() {

    if (
      document.getElementById(
        "arlo-checkout-nudge-styles"
      )
    ) {
      return;
    }


    const style =
      document.createElement(
        "style"
      );


    style.id =
      "arlo-checkout-nudge-styles";


    style.textContent = `

      #${CHECKOUT_NUDGE_ID} {

        position: fixed;

        inset: 0;

        z-index: 2147483000;

        display: flex;

        align-items: center;

        justify-content: center;

        padding: 24px;

        box-sizing: border-box;

        background:
          rgba(24,0,9,.43);

        -webkit-backdrop-filter:
          blur(6px);

        backdrop-filter:
          blur(6px);

        opacity: 0;

        visibility: hidden;

        transition:
          opacity .24s ease,
          visibility .24s ease;

      }


      #${CHECKOUT_NUDGE_ID}.is-open {

        opacity: 1;

        visibility: visible;

      }


      #${CHECKOUT_NUDGE_ID}
      .arlo-checkout-nudge__card {

        position: relative;

        width:
          min(
            100%,
            520px
          );

        box-sizing:
          border-box;

        overflow:
          hidden;

        border:
          1px solid
          rgba(24,0,9,.08);

        border-radius:
          28px;

        background:
          #ffffff;

        box-shadow:
          0 28px 80px
          rgba(24,0,9,.22);

        transform:
          translateY(14px)
          scale(.985);

        transition:
          transform .28s
          cubic-bezier(
            .22,
            1,
            .36,
            1
          );

      }


      #${CHECKOUT_NUDGE_ID}.is-open
      .arlo-checkout-nudge__card {

        transform:
          translateY(0)
          scale(1);

      }


      #${CHECKOUT_NUDGE_ID}
      .arlo-checkout-nudge__accent {

        height: 6px;

        background:
          linear-gradient(
            90deg,
            #008382 0%,
            #b0b0e7 62%,
            #f7d63f 100%
          );

      }


      #${CHECKOUT_NUDGE_ID}
      .arlo-checkout-nudge__inside {

        padding:
          30px 30px 28px;

      }


      #${CHECKOUT_NUDGE_ID}
      .arlo-checkout-nudge__close {

        position: absolute;

        top: 19px;

        right: 19px;

        width: 38px;

        height: 38px;

        display: flex;

        align-items: center;

        justify-content: center;

        padding: 0;

        border: 0;

        border-radius: 50%;

        background:
          rgba(24,0,9,.05);

        color:
          #180009;

        font: inherit;

        font-size: 23px;

        line-height: 1;

        cursor: pointer;

      }


      #${CHECKOUT_NUDGE_ID}
      .arlo-checkout-nudge__eyebrow {

        margin:
          0 48px 13px 0;

        color:
          #008382;

        font-size: 10px;

        line-height: 1.2;

        font-weight: 600;

        letter-spacing: .13em;

        text-transform:
          uppercase;

      }


      #${CHECKOUT_NUDGE_ID}
      .arlo-checkout-nudge__title {

        margin:
          0 42px 14px 0;

        color:
          #180009;

        font-size:
          clamp(
            32px,
            5vw,
            48px
          );

        line-height: .98;

        font-weight: 500;

        letter-spacing:
          -.055em;

      }


      #${CHECKOUT_NUDGE_ID}
      .arlo-checkout-nudge__title span {

        color:
          #008382;

      }


      #${CHECKOUT_NUDGE_ID}
      .arlo-checkout-nudge__copy {

        max-width: 420px;

        margin:
          0 0 21px;

        color:
          rgba(24,0,9,.65);

        font-size: 14px;

        line-height: 1.55;

        font-weight: 400;

      }


      #${CHECKOUT_NUDGE_ID}
      .arlo-checkout-nudge__perks {

        display: grid;

        grid-template-columns:
          1fr 1fr;

        gap: 8px;

        margin-bottom:
          23px;

      }


      #${CHECKOUT_NUDGE_ID}
      .arlo-checkout-nudge__perk {

        min-height: 76px;

        box-sizing:
          border-box;

        padding: 14px;

        border:
          1px solid
          rgba(176,176,231,.26);

        border-radius:
          17px;

        background:
          rgba(176,176,231,.13);

      }


      #${CHECKOUT_NUDGE_ID}
      .arlo-checkout-nudge__perk-label {

        display: block;

        margin-bottom: 6px;

        color:
          #008382;

        font-size: 9px;

        line-height: 1;

        font-weight: 600;

        letter-spacing:
          .09em;

        text-transform:
          uppercase;

      }


      #${CHECKOUT_NUDGE_ID}
      .arlo-checkout-nudge__perk-copy {

        display: block;

        color:
          #180009;

        font-size: 13px;

        line-height: 1.28;

        font-weight: 500;

      }

            #${CHECKOUT_NUDGE_ID}
      .arlo-checkout-nudge__offer {

        margin:
          22px 0 24px;

        padding:
          18px 18px 16px;

        border:
          1px solid
          rgba(0,131,130,.16);

        border-radius:
          18px;

        background:
          linear-gradient(
            135deg,
            rgba(176,176,231,.13),
            rgba(255,255,255,.96)
          );

      }


      #${CHECKOUT_NUDGE_ID}
      .arlo-checkout-nudge__offer-label {

        display: block;

        margin-bottom:
          13px;

        color:
          #008382;

        font-size:
          10px;

        line-height: 1;

        font-weight: 600;

        letter-spacing:
          .12em;

      }


      #${CHECKOUT_NUDGE_ID}
      .arlo-checkout-nudge__offer-items {

        display: grid;

        gap: 8px;

      }


      #${CHECKOUT_NUDGE_ID}
      .arlo-checkout-nudge__offer-item {

        display: flex;

        align-items: center;

        gap: 10px;

        color:
          #180009;

        font-size:
          18px;

        line-height:
          1.15;

        font-weight:
          500;

        letter-spacing:
          -.02em;

      }


      #${CHECKOUT_NUDGE_ID}
      .arlo-checkout-nudge__offer-plus {

        width: 24px;
        height: 24px;

        flex:
          0 0 24px;

        display: flex;

        align-items: center;

        justify-content: center;

        border-radius:
          50%;

        background:
          #008382;

        color:
          #ffffff;

        font-size:
          17px;

        line-height: 1;

      }


      #${CHECKOUT_NUDGE_ID}
.arlo-checkout-nudge__progress {

  margin:
    24px 0 26px;

}


      #${CHECKOUT_NUDGE_ID}
      .arlo-checkout-nudge__progress-top {

        display: flex;

        align-items: center;

        justify-content:
          space-between;

        gap: 14px;

        margin-bottom:
          8px;

        color:
          rgba(24,0,9,.5);

        font-size: 10px;

        line-height: 1.2;

      }


      #${CHECKOUT_NUDGE_ID}
.arlo-checkout-nudge__track {

  --arlo-progress: 0%;

  position: relative;

  width: 100%;

  height: 8px;

  overflow: hidden;

  border-radius: 999px;

  background:
    linear-gradient(
      90deg,
      #008382 0%,
      #008382 var(--arlo-progress),
      rgba(176,176,231,.24) var(--arlo-progress),
      rgba(176,176,231,.24) 100%
    );

  transition:
    background .35s ease;

}

      #${CHECKOUT_NUDGE_ID}
      .arlo-checkout-nudge__actions {

        display: grid;

        grid-template-columns:
          minmax(0,1fr)
          minmax(0,1fr);

        gap: 10px;

      }


      #${CHECKOUT_NUDGE_ID}
      .arlo-checkout-nudge__button {

        min-height: 52px;

        display: flex;

        align-items: center;

        justify-content: center;

        box-sizing:
          border-box;

        padding:
          11px 16px;

        border-radius:
          999px;

        font: inherit;

        font-size: 13px;

        line-height: 1.2;

        cursor: pointer;

      }


      #${CHECKOUT_NUDGE_ID}
      .arlo-checkout-nudge__button--shop {

        border:
          1px solid
          #180009;

        background:
          #180009;

        color:
          #ffffff;

        font-weight: 500;

      }


      #${CHECKOUT_NUDGE_ID}
      .arlo-checkout-nudge__button--checkout {

        border:
          1px solid
          rgba(24,0,9,.15);

        background:
          #ffffff;

        color:
          rgba(24,0,9,.64);

        font-weight: 400;

      }


      #${CHECKOUT_NUDGE_ID}
      .arlo-checkout-nudge__small {

        margin:
          13px 0 0;

        color:
          rgba(24,0,9,.37);

        font-size: 9px;

        line-height: 1.35;

        text-align:
          center;

      }


      @media screen and (max-width:749px) {

        #${CHECKOUT_NUDGE_ID} {

          align-items:
            flex-end;

          padding:
            10px
            9px
            calc(
              10px +
              env(
                safe-area-inset-bottom
              )
            );

        }


        #${CHECKOUT_NUDGE_ID}
        .arlo-checkout-nudge__card {

          width: 100%;

          border-radius:
            25px
            25px
            20px
            20px;

          transform:
            translateY(36px);

        }


        #${CHECKOUT_NUDGE_ID}.is-open
        .arlo-checkout-nudge__card {

          transform:
            translateY(0);

        }


        #${CHECKOUT_NUDGE_ID}
        .arlo-checkout-nudge__inside {

          padding:
            24px
            18px
            17px;

        }


        #${CHECKOUT_NUDGE_ID}
        .arlo-checkout-nudge__close {

          top: 15px;

          right: 15px;

          width: 36px;

          height: 36px;

        }


        #${CHECKOUT_NUDGE_ID}
        .arlo-checkout-nudge__title {

          margin-right:
            40px;

          font-size:
            38px;

        }


        #${CHECKOUT_NUDGE_ID}
        .arlo-checkout-nudge__copy {

          font-size:
            13px;

        }


        #${CHECKOUT_NUDGE_ID}
        .arlo-checkout-nudge__perks {

          gap: 7px;

        }


        #${CHECKOUT_NUDGE_ID}
        .arlo-checkout-nudge__perk {

          min-height:
            69px;

          padding:
            12px;

        }


        #${CHECKOUT_NUDGE_ID}
        .arlo-checkout-nudge__actions {

          grid-template-columns:
            1fr;

        }


        #${CHECKOUT_NUDGE_ID}
        .arlo-checkout-nudge__button {

          min-height:
            50px;

        }


        #${CHECKOUT_NUDGE_ID}
        .arlo-checkout-nudge__button--checkout {

          order: 2;

        }

      }

    `;


    document.head.appendChild(
      style
    );

  }
  function createCheckoutNudge() {

    let nudge =
      document.getElementById(
        CHECKOUT_NUDGE_ID
      );


    if (nudge) {
      return nudge;
    }


    injectCheckoutNudgeStyles();


    nudge =
      document.createElement(
        "div"
      );


    nudge.id =
      CHECKOUT_NUDGE_ID;


    nudge.setAttribute(
      "aria-hidden",
      "true"
    );


    nudge.innerHTML = `

      <div
        class="arlo-checkout-nudge__card"
        role="dialog"
        aria-modal="true"
        aria-labelledby="arlo-checkout-nudge-title"
      >

        <div
          class="arlo-checkout-nudge__accent"
        ></div>


        <div
          class="arlo-checkout-nudge__inside"
        >

          <button
            type="button"
            class="arlo-checkout-nudge__close"
            aria-label="Close"
            data-arlo-checkout-close
          >
            ×
          </button>


          <p
            class="arlo-checkout-nudge__eyebrow"
          >
            BEFORE YOU GO
          </p>


          <h2
            id="arlo-checkout-nudge-title"
            class="arlo-checkout-nudge__title"
          >
            You’re only
            <span
              data-arlo-checkout-remaining
            >
              £0.00
            </span>
            away.
          </h2>


          <p
  class="arlo-checkout-nudge__copy"
>
  Reach £30 in qualifying products and
  we’ll add both to your order automatically.
</p>


<div
  class="arlo-checkout-nudge__offer"
>

  <span
    class="arlo-checkout-nudge__offer-label"
  >
    REACH £30 AND GET
  </span>


  <div
    class="arlo-checkout-nudge__offer-items"
  >

    <div
      class="arlo-checkout-nudge__offer-item"
    >
      <span
        class="arlo-checkout-nudge__offer-plus"
      >
        +
      </span>

      <span>
        FREE arlo.® GIFT
      </span>
    </div>


    <div
      class="arlo-checkout-nudge__offer-item"
    >
      <span
        class="arlo-checkout-nudge__offer-plus"
      >
        +
      </span>

      <span>
        FREE UK DELIVERY
      </span>
    </div>

  </div>

</div>



          <div
            class="arlo-checkout-nudge__progress"
          >

            <div
              class="arlo-checkout-nudge__progress-top"
            >

              <span
                data-arlo-checkout-progress-copy
              >
                £0.00 of £30
              </span>

              <span>
                £30 unlock
              </span>

            </div>


            <div
              class="arlo-checkout-nudge__track"
              role="progressbar"
              aria-valuemin="0"
              aria-valuemax="100"
              aria-valuenow="0"
              data-arlo-checkout-progress
            >

              <div
                class="arlo-checkout-nudge__fill"
                data-arlo-checkout-fill
              ></div>

            </div>

          </div>


          <div
            class="arlo-checkout-nudge__actions"
          >

            <button
              type="button"
              class="
                arlo-checkout-nudge__button
                arlo-checkout-nudge__button--shop
              "
              data-arlo-keep-shopping
            >
              Keep shopping
            </button>


            <button
              type="button"
              class="
                arlo-checkout-nudge__button
                arlo-checkout-nudge__button--checkout
              "
              data-arlo-checkout-anyway
            >
              Checkout anyway
            </button>

          </div>


          <p
            class="arlo-checkout-nudge__small"
          >
            Only qualifying products count towards
            the £30 Premium Order.
          </p>

        </div>

      </div>

    `;


    document.body.appendChild(
      nudge
    );


    /*
      CLOSE BUTTON
    */
    nudge
      .querySelector(
        "[data-arlo-checkout-close]"
      )
      ?.addEventListener(
        "click",
        () => {

          closeCheckoutNudge();

        }
      );


    /*
      CLICKING THE DARK BACKDROP
    */
    nudge.addEventListener(
      "click",
      (event) => {

        if (
          event.target === nudge
        ) {

          closeCheckoutNudge();

        }

      }
    );


    /*
      KEEP SHOPPING
    */
    nudge
      .querySelector(
        "[data-arlo-keep-shopping]"
      )
      ?.addEventListener(
        "click",
        () => {

          closeCheckoutNudge();


          /*
            If the customer came from the
            cart drawer, close the drawer so
            they can immediately keep shopping.
          */
          const drawerClose =
            document.querySelector(
              [
                "cart-drawer button[aria-label='Close']",
                "cart-drawer .drawer__close",
                "#CartDrawer button[aria-label='Close']",
                "#CartDrawer .drawer__close"
              ].join(",")
            );


          if (drawerClose) {

            drawerClose.click();

          }

        }
      );


    /*
      CHECKOUT ANYWAY
    */
    nudge
      .querySelector(
        "[data-arlo-checkout-anyway]"
      )
      ?.addEventListener(
        "click",
        () => {

          const element =
            approvedCheckoutElement;


          const href =
            approvedCheckoutHref;


          closeCheckoutNudge();


          /*
            Link-style checkout.
          */
          if (href) {

            window.location.href =
              href;

            return;

          }


          /*
            Button-style Shopify checkout.

            Give the original button one
            approved pass through our interceptor.
          */
          if (
            element &&
            document.contains(
              element
            )
          ) {

            element.setAttribute(
              "data-arlo-checkout-approved",
              "true"
            );


            window.setTimeout(
              () => {

                element.click();


                window.setTimeout(
                  () => {

                    element.removeAttribute(
                      "data-arlo-checkout-approved"
                    );

                  },
                  1200
                );

              },
              30
            );


            return;

          }


          /*
            Safe fallback.
          */
          window.location.href =
            `${rootUrl()}checkout`;

        }
      );


    return nudge;
  }


  function closeCheckoutNudge() {

    const nudge =
      document.getElementById(
        CHECKOUT_NUDGE_ID
      );


    if (!nudge) {

      checkoutNudgeOpen =
        false;

      return;

    }


    nudge.classList.remove(
      "is-open"
    );


    nudge.setAttribute(
      "aria-hidden",
      "true"
    );


    document.documentElement
      .style
      .removeProperty(
        "overflow"
      );


    document.body
      .style
      .removeProperty(
        "overflow"
      );


    checkoutNudgeOpen =
      false;

  }


  function openCheckoutNudge(
    totals,
    checkoutElement,
    checkoutHref
  ) {

    const nudge =
      createCheckoutNudge();


    const subtotal =
      Number(
        totals?.subtotal || 0
      );


    const remaining =
      Math.max(
        PREMIUM_THRESHOLD -
        subtotal,
        0
      );


    const percentage =
      Math.min(
        Math.round(
          (
            subtotal /
            PREMIUM_THRESHOLD
          ) * 100
        ),
        100
      );


    const remainingElement =
      nudge.querySelector(
        "[data-arlo-checkout-remaining]"
      );


    const progressCopy =
      nudge.querySelector(
        "[data-arlo-checkout-progress-copy]"
      );


    const progress =
      nudge.querySelector(
        "[data-arlo-checkout-progress]"
      );


    const fill =
      nudge.querySelector(
        "[data-arlo-checkout-fill]"
      );


    if (remainingElement) {

      remainingElement.textContent =
        money(
          remaining
        );

    }


    if (progressCopy) {

      progressCopy.textContent =
        `${money(subtotal)} of £30`;

    }


    if (progress) {

      progress.setAttribute(
        "aria-valuenow",
        String(
          percentage
        )
      );

    }

    if (progress) {

  progress.style.setProperty(
    "--arlo-progress",
    `${percentage}%`
  );

}

     approvedCheckoutElement =
      checkoutElement || null;


    approvedCheckoutHref =
      checkoutHref || null;


    checkoutNudgeOpen =
      true;


    nudge.classList.add(
      "is-open"
    );


    nudge.setAttribute(
      "aria-hidden",
      "false"
    );


    document.documentElement
      .style
      .setProperty(
        "overflow",
        "hidden"
      );


    document.body
      .style
      .setProperty(
        "overflow",
        "hidden"
      );


    window.setTimeout(
      () => {

        nudge
          .querySelector(
            "[data-arlo-keep-shopping]"
          )
          ?.focus();

      },
      80
    );

  }


  /*
    Finds checkout buttons in both
    the main cart and cart drawer.
  */
  function isCheckoutElement(
    element
  ) {

    if (
      !(element instanceof Element)
    ) {

      return false;

    }


    const candidate =
      element.closest(
        [
          "[name='checkout']",
          "[type='submit'][name='checkout']",
          "button[name='checkout']",
          "a[href*='/checkout']",
          "[href$='/checkout']",
          "[data-checkout]",
          "[data-cart-checkout]",
          ".cart__checkout-button",
          "#checkout"
        ].join(",")
      );


    if (!candidate) {

      return false;

    }


    /*
      Anything inside our popup should
      never be interpreted as a brand-new
      checkout attempt.
    */
    if (
      candidate.closest(
        `#${CHECKOUT_NUDGE_ID}`
      )
    ) {

      return false;

    }


    return candidate;
  }


  function getCheckoutHref(
    element
  ) {

    if (!element) {

      return null;

    }


    if (
      element instanceof
      HTMLAnchorElement
    ) {

      return (
        element.href ||
        null
      );

    }


    const href =
      element.getAttribute?.(
        "href"
      );


    return (
      href ||
      null
    );

  }


  /*
    Continue through Shopify checkout
    without reopening the popup.
  */
  function continueCheckout(
    checkoutElement
  ) {

    if (!checkoutElement) {

      window.location.href =
        `${rootUrl()}checkout`;

      return;

    }


    const href =
      getCheckoutHref(
        checkoutElement
      );


    if (href) {

      window.location.href =
        href;

      return;

    }


    checkoutElement.setAttribute(
      "data-arlo-checkout-approved",
      "true"
    );


    window.setTimeout(
      () => {

        checkoutElement.click();


        window.setTimeout(
          () => {

            checkoutElement
              .removeAttribute(
                "data-arlo-checkout-approved"
              );

          },
          1200
        );

      },
      20
    );

  }


  async function evaluateCheckoutAttempt(
    checkoutElement
  ) {

    if (
      checkoutEvaluationInProgress
    ) {

      return;

    }


    checkoutEvaluationInProgress =
      true;


    try {

      /*
        Always use a completely fresh cart
        at the instant Checkout is clicked.
      */
      const cart =
        await getCart();


      const totals =
        await getPremiumOrderTotals(
          cart
        );


      const hasQualifyingProducts =
        totals.qualifyingItemCount >
        0;


      const alreadyUnlocked =
        totals.subtotal >=
        PREMIUM_THRESHOLD;


      /*
        ONLY EXCLUDED ITEMS IN CART

        No popup.
      */
      if (
        !hasQualifyingProducts
      ) {

        continueCheckout(
          checkoutElement
        );

        return;

      }


      /*
        £30+ QUALIFYING SPEND

        They've already unlocked it,
        so don't annoy them.
      */
      if (
        alreadyUnlocked
      ) {

        continueCheckout(
          checkoutElement
        );

        return;

      }


      /*
        QUALIFYING PRODUCTS ARE PRESENT
        BUT QUALIFYING SPEND IS BELOW £30.

        This is the only situation in which
        the popup appears.
      */
      openCheckoutNudge(
        totals,
        checkoutElement,
        getCheckoutHref(
          checkoutElement
        )
      );

    }


    catch (error) {

      console.error(
        "[Premium Order checkout check]",
        error
      );


      /*
        Checkout must never be blocked
        because our promotional logic failed.
      */
      continueCheckout(
        checkoutElement
      );

    }


    finally {

      checkoutEvaluationInProgress =
        false;

    }

  }


  /*
    ============================================================
    CHECKOUT CLICK INTERCEPTOR
    ============================================================
  */

  document.addEventListener(
    "click",
    (event) => {

      const checkoutElement =
        isCheckoutElement(
          event.target
        );


      if (!checkoutElement) {

        return;

      }


      /*
        This is the second, approved click
        produced by Checkout Anyway or by
        continueCheckout().

        Leave it completely alone.
      */
      if (
        checkoutElement.getAttribute(
          "data-arlo-checkout-approved"
        ) === "true"
      ) {

        return;

      }


      if (
        checkoutNudgeOpen
      ) {

        event.preventDefault();

        event.stopPropagation();

        event.stopImmediatePropagation();

        return;

      }


      /*
        Stop Shopify checkout very briefly
        while we calculate qualifying spend.
      */
      event.preventDefault();

      event.stopPropagation();

      event.stopImmediatePropagation();


      evaluateCheckoutAttempt(
        checkoutElement
      );

    },
    true
  );


  /*
    ============================================================
    CHECKOUT FORM SUBMIT INTERCEPTOR
    ============================================================

    Some theme/cart versions submit the form
    directly, so this catches that route too.
  */

  document.addEventListener(
    "submit",
    (event) => {

      const form =
        event.target;


      if (
        !(form instanceof HTMLFormElement)
      ) {

        return;

      }


      const submitter =
        event.submitter;


      const checkoutElement =
        submitter
          ? isCheckoutElement(
              submitter
            )
          : null;


      if (!checkoutElement) {

        return;

      }


      if (
        checkoutElement.getAttribute(
          "data-arlo-checkout-approved"
        ) === "true"
      ) {

        return;

      }


      event.preventDefault();

      event.stopPropagation();

      event.stopImmediatePropagation();


      evaluateCheckoutAttempt(
        checkoutElement
      );

    },
    true
  );


  /*
    Escape closes the popup.
  */
  document.addEventListener(
    "keydown",
    (event) => {

      if (
        event.key === "Escape" &&
        checkoutNudgeOpen
      ) {

        closeCheckoutNudge();

      }

    }
  );


  /*
    ============================================================
    INITIAL LOAD
    ============================================================
  */

  function initialisePremiumOrder() {

    createCheckoutNudge();

    updateEverything();

  }


  if (
    document.readyState ===
    "loading"
  ) {

    document.addEventListener(
      "DOMContentLoaded",
      () => {

        initialisePremiumOrder();

      },
      {
        once: true
      }
    );

  }

  else {

    initialisePremiumOrder();

  }


  /*
    Recalculate when returning to the page
    using the browser back button.
  */
  window.addEventListener(
    "pageshow",
    (event) => {

      if (
        event.persisted
      ) {

        queueUpdate(
          250
        );

      }

    }
  );


})();
